import AuthService from "@/services/auth.service";

// The admin area is gated on this specific account rather than a role.
export const ADMIN_EMAIL = "admin@gekkotech.io";

export function isAdmin() {
  const user = AuthService.getUser();
  return !!user && user.email === ADMIN_EMAIL;
}

// Accounts allowed to look at any dashboard, not just their assigned one.
const DASHBOARD_SWITCHERS = [ADMIN_EMAIL, "majid@ekspertiza.ba"];

// Reports are company-wide figures: restricted to these accounts, which is
// narrower than the VIEW_REPORTS permission the ADMIN role carries. Mirrors
// components/predmet/access.py on the server.
const REPORT_VIEWERS = [
  ADMIN_EMAIL,
  "majid@ekspertiza.ba",
  "selma@ekspertiza.ba",
  "nedim@ekspertiza.ba",
];

export function canViewReports() {
  const user = AuthService.getUser();
  return !!user && REPORT_VIEWERS.indexOf(user.email) !== -1;
}

export function canSwitchDashboards() {
  const user = AuthService.getUser();
  return !!user && DASHBOARD_SWITCHERS.indexOf(user.email) !== -1;
}
